export default __webpack_public_path__ + "static/media/tailor.aed706b1.png";